import { clsx } from 'clsx';
import classes from './ActionList.module.css.js';
import { jsx } from 'react/jsx-runtime';

/**
 * Visually separates `Items` or `Groups` in an `ActionList`.
 */
const Divider = ({
  className,
  style
}) => {
  return /*#__PURE__*/jsx("li", {
    className: clsx(className, classes.Divider),
    style: style,
    "aria-hidden": "true",
    "data-component": "ActionList.Divider"
  });
};
Divider.displayName = "Divider";
Divider.__SLOT__ = Symbol('ActionList.Divider');

export { Divider };
